export default {
  labels: {
    signed_by: '{{name}} allekirjoitti {{date}}',
    signed_by_no_date: '{{name}} allekirjoitti',
  },
  buttons: {
    retry: 'Yritä uudelleen',
  },
  errors: {
    load_failed: 'Sopimusta ei voitu ladata. Tarkista yhteytesi ja yritä uudelleen.',
  },
};
